import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { LogOut } from 'lucide-react';
import {useAuth} from "../context/authContext.tsx";
import { LogoutService } from "../services/employee.ts";

interface ProfileMenuProps {
  userPhoto?: string;
  userName?: string;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ userPhoto, userName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {employeeI, setEmp} = useAuth()

  const handleLogout = async () => {
    try {
      await LogoutService();
    } catch (error) {
      console.error('Failed to logout cleanly:', error);
    } finally {
      setEmp(undefined);
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 focus:outline-none"
      >
        <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200">
          <img
            src={employeeI?.profile_photo}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </div>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
          <div className="px-4 py-2 text-sm text-gray-700 border-b">
            {userName || employeeI?.fname} {employeeI?.lname}
          </div>
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
          >
            <LogOut size={16} />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu; 
